module.exports = __webpack_public_path__ + "images/4afc84ead4fcd93182b0b41cb9f61f16.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/EstrangeloMidyat.woff2
// module id = 1153
// module chunks = 0